import createIcon from '../../createIcon';

/**
 * @component @name Diversity3
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNi4zMiAxMy4wMUM3LjI4IDEzLjAzIDguMTcgMTMuNTEgOC43NyAxNC4zNUM5LjUgMTUuMzggMTAuNzEgMTYgMTIgMTZDMTMuMjkgMTYgMTQuNSAxNS4zOCAxNS4yMyAxNC4zNEMxNS44MyAxMy41IDE2LjcyIDEzLjAyIDE3LjY4IDEzQzE2Ljk2IDExLjc4IDE0LjA4IDExIDEyIDExQzkuOTMgMTEgNy4wNCAxMS43OCA2LjMyIDEzLjAxWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTQgMTNDNS42NiAxMyA3IDExLjY2IDcgMTBDNyA4LjM0IDUuNjYgNyA0IDdDMi4zNCA3IDEgOC4zNCAxIDEwQzEgMTEuNjYgMi4zNCAxMyA0IDEzWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTIwIDEzQzIxLjY2IDEzIDIzIDExLjY2IDIzIDEwQzIzIDguMzQgMjEuNjYgNyAyMCA3QzE4LjM0IDcgMTcgOC4zNCAxNyAxMEMxNyAxMS42NiAxOC4zNCAxMyAyMCAxM1oiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xMiAxMEMxMy42NiAxMCAxNSA4LjY2IDE1IDdDMTUgNS4zNCAxMy42NiA0IDEyIDRDMTAuMzQgNCA5IDUuMzQgOSA3QzkgOC42NiAxMC4zNCAxMCAxMiAxMFoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yMSAxNEgxNy43M0MxNi45NiAxNCAxNi4zOCAxNC40NSAxNi4wNSAxNC45MkMxNi4wMSAxNC45OCAxNC42OSAxNyAxMiAxN0MxMC41NyAxNyA4Ljk3IDE2LjM2IDcuOTUgMTQuOTJDNy41NiAxNC4zNyA2Ljk1IDE0IDYuMjcgMTRIM0MxLjkgMTQgMSAxNC45IDEgMTZWMjBIOFYxNy43NEM5LjE1IDE4LjU0IDEwLjU0IDE5IDEyIDE5QzEzLjQ2IDE5IDE0Ljg1IDE4LjU0IDE2IDE3Ljc0VjIwSDIzVjE2QzIzIDE0LjkgMjIuMSAxNCAyMSAxNFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Diversity3 = createIcon('Diversity3', [
  [
    'path',
    {
      d: 'M6.32 13.01C7.28 13.03 8.17 13.51 8.77 14.35C9.5 15.38 10.71 16 12 16C13.29 16 14.5 15.38 15.23 14.34C15.83 13.5 16.72 13.02 17.68 13C16.96 11.78 14.08 11 12 11C9.93 11 7.04 11.78 6.32 13.01Z',
      key: '2jo82t',
    },
  ],
  [
    'path',
    {
      d: 'M4 13C5.66 13 7 11.66 7 10C7 8.34 5.66 7 4 7C2.34 7 1 8.34 1 10C1 11.66 2.34 13 4 13Z',
      key: 'cdowra',
    },
  ],
  [
    'path',
    {
      d: 'M20 13C21.66 13 23 11.66 23 10C23 8.34 21.66 7 20 7C18.34 7 17 8.34 17 10C17 11.66 18.34 13 20 13Z',
      key: 'x3nvb5',
    },
  ],
  [
    'path',
    {
      d: 'M12 10C13.66 10 15 8.66 15 7C15 5.34 13.66 4 12 4C10.34 4 9 5.34 9 7C9 8.66 10.34 10 12 10Z',
      key: 'r71wft',
    },
  ],
  [
    'path',
    {
      d: 'M21 14H17.73C16.96 14 16.38 14.45 16.05 14.92C16.01 14.98 14.69 17 12 17C10.57 17 8.97 16.36 7.95 14.92C7.56 14.37 6.95 14 6.27 14H3C1.9 14 1 14.9 1 16V20H8V17.74C9.15 18.54 10.54 19 12 19C13.46 19 14.85 18.54 16 17.74V20H23V16C23 14.9 22.1 14 21 14Z',
      key: '1p59vi',
    },
  ],
]);

export default Diversity3;
